@if (columnEntries) {
  <div class="variable-column-container">
    @for (entry of columnEntries; track entry) {
      <div
        class="variable-column-entry"
        [ngStyle]="{'width': entry.percentWidth + '%'}"
        >
        <app-custom-page-section [sectionData]="entry.section"></app-custom-page-section>
      </div>
    }
  </div>
}
